import React, { useEffect, useState } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { loadModules } from "esri-loader";
import { UrlServices, UrlServicesTypeTrasnporte, UrlServicesTypeTrasnporteName, UrlServicesNode, UrlServicesfilterNode, createRequestURLs } from "../../../../.config";
import dateFormat from "dateformat";
import { BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import { FaSpinner } from "react-icons/fa";
import { RiCheckboxCircleFill } from "react-icons/ri";
import Button from 'react-bootstrap/Button';
import { TODIS_FORM_FIELD_OPTIONS_DESC, TODIS_FORM_FIELD, TODIS_FORM_DSC, TODIS_FORM_FIELD_DATE, TODIS_FORM_FIELD_DATE_YEAR, TODIS_FORM_FIELD_DATE_RQ, TODIS_FORM_FIELD_OPTIONS_GDB, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE } from "../../../../components/Forms";
import { AuxiliaryService } from '../../../../HttpService/AuxiliaryService';
import { Formik, Field, Form, ErrorMessage, useFormik } from 'formik';
import "../../../DataCollection/style.css";
import { TODIS_MODAL } from "../../../../components/Modals/Modal";
import { TODIS_TASK, TASK } from "../../../../.config/form/network_performance";
import style from "../Requests.module.scss";
import { RequestService } from "../../../../HttpService/RequestService";
import { OrganizationsService } from "../../../../HttpService/OrganizationService";
import Swal from "sweetalert2";

const FormRequest = (props) => {

    const [tasks, setTasks] = useState([]);
    const [isHidden, setIsHidden] = useState(true);
    const [isHiddenTrasnport, setIsHiddenTrasnport] = useState(true);
    const [isHiddenCore, setIsHiddenCore] = useState(true);
    const [Ocultar, setOcultar] = useState(false);
    const [OcultarType, setOcultarType] = useState(false);
    const [NameRouteID, setNameRouteID] = useState("ROUTE ID");
    const [transports, setTransports] = useState([]);
    const [idTransport, setidTransport] = useState(0);
    const [input, setInput] = useState('');
    const [ValueGDB, setValueGDB] = useState([]);

    const [regionals, setRegionals] = useState([]);
    const [regionalsGeo, setRegionalsGeo] = useState([]);
    const [rp, setRP] = useState("");
    const [showNoData, setShowNoData] = useState(false);
    const [isLoadingRoutes, setIsLoadingRoutes] = useState(false);

    const [personals, setPersonals] = useState([
        {
            idAuxtabledetail: "john.doe",
            txtDescription: "John Doe"
        }
    ]);

    const [tentCategory, setTentCategory] = useState([]);

    const [routers, setRouters] = useState([]);
    const [startNode, setstartNode] = useState([]);
    const [endNode, setendNode] = useState([]);

    const isLikelyJwt = (token) => typeof token === "string" && token.split(".").length === 3;

    const getArcgisToken = async (forceRefresh = false) => {
        const cachedToken = sessionStorage.getItem("arcgisServerToken");
        if (!forceRefresh && cachedToken && !isLikelyJwt(cachedToken)) {
            return cachedToken;
        }

        if (cachedToken && isLikelyJwt(cachedToken)) {
            sessionStorage.removeItem("arcgisServerToken");
        }

        const response = await fetch("https://todis.transport-community.org/api/auth/returnToken");
        if (!response.ok) {
            throw new Error(`Token endpoint HTTP ${response.status}`);
        }

        const data = await response.json();
        if (!data?.token) {
            throw new Error("No ArcGIS token in response");
        }

        sessionStorage.setItem("arcgisServerToken", data.token);
        return data.token;
    };

    const executeArcgisQuery = async (serviceUrl, queryParams) => {
        const buildArcgisError = (arcgisError) => {
            const error = new Error(arcgisError?.message || "ArcGIS query error");
            error.arcgisCode = arcgisError?.code;
            error.arcgisDetails = arcgisError?.details;
            return error;
        };

        const doPost = async (extraParams = {}) => {
            const params = new URLSearchParams({
                f: "json",
                ...queryParams,
                ...extraParams,
            });

            const response = await fetch(serviceUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                },
                body: params.toString(),
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            return response.json();
        };

        let data = await doPost();
        const firstErrorMessage = data?.error?.message || "";
        const tokenError = /token/i.test(firstErrorMessage);

        if (tokenError) {
            const token = await getArcgisToken(false);
            data = await doPost({ token, referer: "https://todis.transport-community.org/" });

            const secondErrorMessage = data?.error?.message || "";
            const staleTokenError = /token/i.test(secondErrorMessage) && /(invalid|expired|required)/i.test(secondErrorMessage);
            if (staleTokenError) {
                const refreshedToken = await getArcgisToken(true);
                data = await doPost({ token: refreshedToken, referer: "https://todis.transport-community.org/" });
            }
        }

        if (data?.error) {
            throw buildArcgisError(data.error);
        }

        return data;
    };

    const getGeometryPointCount = (geometry) => {
        if (!geometry?.rings || !Array.isArray(geometry.rings)) {
            return 0;
        }

        return geometry.rings.reduce((total, ring) => {
            if (!Array.isArray(ring)) return total;
            return total + ring.length;
        }, 0);
    };

    const geometryToEnvelope = (geometry) => {
        if (!geometry?.rings || !Array.isArray(geometry.rings)) {
            return null;
        }

        let xmin = Infinity;
        let ymin = Infinity;
        let xmax = -Infinity;
        let ymax = -Infinity;

        geometry.rings.forEach((ring) => {
            if (!Array.isArray(ring)) return;
            ring.forEach((point) => {
                if (!Array.isArray(point) || point.length < 2) return;
                const x = Number(point[0]);
                const y = Number(point[1]);
                if (!Number.isFinite(x) || !Number.isFinite(y)) return;
                xmin = Math.min(xmin, x);
                ymin = Math.min(ymin, y);
                xmax = Math.max(xmax, x);
                ymax = Math.max(ymax, y);
            });
        });

        if (![xmin, ymin, xmax, ymax].every(Number.isFinite)) {
            return null;
        }

        return {
            xmin,
            ymin,
            xmax,
            ymax,
            spatialReference: geometry.spatialReference,
        };
    };

    const getDataSelect = async () => {
        try {
            //get the geometry of the countries
            // const regionalPartnarGeoURL = "https://todis.transport-community.org/server/rest/services/Todis_Border/MapServer/22/query?where=1%3D1&text=&objectIds=&time=&timeRelation=esriTimeRelationOverlaps&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&sqlFormat=none&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=html"
            const auxiliaries = await new AuxiliaryService("auxData/typeform,typetransport,regionalpartner,tentcategory").getAuxiliaries();

            auxiliaries.map(item => {
                if (item.txtNameTable == "typeform") {
                    //remove the EU Acquis
                    //console.log(item.auxtableDetailsDTOList);
                    let items = item.auxtableDetailsDTOList.filter((itm) => { return itm.idAuxtabledetail != 86 })
                    //console.log(items);
                    setTasks(items)
                }
                if (item.txtNameTable == "typetransport")
                    setTransports(item.auxtableDetailsDTOList)
                if (item.txtNameTable == "regionalpartner") {
                    let list = item.auxtableDetailsDTOList.sort((a, b) =>
                        a.txtDescription.localeCompare(b.txtDescription));
                    //console.log("regionals: ", list)
                    setRegionals(list)
                }
                if (item.txtNameTable == "tentcategory")
                    setTentCategory(item.auxtableDetailsDTOList)
            })

            getRegionalPartnerGeo();
            //get regional partners
            getRegionalUsers();
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    const getRegionalUsers = async () => {
        let users = await new RequestService("workflow/request/regionals").get();
        if (rp !== "") {
            let matchingOrganizationIds = [];
    
            let res = await new OrganizationsService("organization/organizations/summary").getDataOrganizations(null);
    
            for (const organization of res) {
                let coincidences = false;
    
                for (const regionalPartner of organization.regionalPartners) {
                    if (regionalPartner.countrycode === rp) {
                        coincidences = true;
                        break;
                    }
                }
                if (coincidences) {
                    matchingOrganizationIds.push(organization.id);
                }
            }
            users = users.filter(u => matchingOrganizationIds.includes(u.organizationId));
        }
    
        // Ordenar los usuarios alfabéticamente por first_name y luego por last_name
        users.sort((a, b) => {
            const nameA = a.first_name.toLowerCase(); // Convertir a minúsculas para la comparación
            const nameB = b.first_name.toLowerCase();
            if (nameA < nameB) return -1; // a va antes que b
            if (nameA > nameB) return 1; // b va antes que a
            // Si son iguales, comparar por last_name
            const lastNameA = a.last_name.toLowerCase();
            const lastNameB = b.last_name.toLowerCase();
            if (lastNameA < lastNameB) return -1;
            if (lastNameA > lastNameB) return 1;
            return 0; // Son iguales
        });
    
        let persons = users.map((itm) => {
            return {
                "idAuxtabledetail": itm.username,
                "txtDescription": itm.first_name + " " + itm.last_name
            }
        });
    
        if (users)
            setPersonals(persons);
    }
    
    const getRegionalPartnerGeo = async () => {
        //console.log("get boundaries data..");
        loadModules(["esri/rest/support/Query", "esri/rest/query"]).then(([Query, query]) => {
            let queryUrl = createRequestURLs.boundaries;
            // create the Query object
            let queryObject = new Query();
            queryObject.where = "1=1";
            queryObject.returnGeometry = true;
            queryObject.outFields = ["country_code", "country_name"];

            query.executeQueryJSON(queryUrl, queryObject).then(function (results) {
                //store the boundaries geo data
                if (results.features.length > 0)
                    setRegionalsGeo(results.features)
            }).catch(function (error) {
                console.log("Something went wrong while retreiving the regional partners boundaries", error);
            });
        });
    }

    useEffect(() => {
        getDataSelect();
    }, []);

    useEffect(() => {
        getRegionalUsers();
    }, [rp]);

    const typeOnchage = (e, id) => {

        if (e.target.value == 86) {

            setIsHidden(false);
        }
        else {
            setIsHidden(true);

        }
        //console.log(e.target.value);
    }

    const regionalOnChange = (e) => {
        // console.log("regional partner changed", e.target.value);
        // console.log("regionals", regionals);
        let nextRegionalPartner = "";
        if (e.target.value === "") {
            setRP("");
        } else {
            let chosen = regionals.find(item => item.idAuxtabledetail == e.target.value);
            // console.log("regional chosen", chosen);
            nextRegionalPartner = chosen?.countryCode || "";
            setRP(nextRegionalPartner);
        }
        if (idTransport) {
            loadRouteOptions(idTransport, nextRegionalPartner);
        }

    }

    const loadRouteOptions = async (transportId, regionalPartnerCode = rp) => {
        const parsedId = parseInt(transportId, 10);

        if (!transportId || Number.isNaN(parsedId)) {
            setidTransport(0);
            setRouters([]);
            setIsLoadingRoutes(false);
            return;
        }

        var service = UrlServicesTypeTrasnporte[parsedId];
        var serviceName = UrlServicesTypeTrasnporteName[parsedId];

        if (!service || !serviceName) {
            setRouters([]);
            setIsLoadingRoutes(false);
            return;
        }

        setIsLoadingRoutes(true)
        setRouters([]);
        setstartNode([]);
        setendNode([]);
        setShowNoData(false);

        try {
            const queryParams = {
                where: "1=1",
                outFields: serviceName,
                returnGeometry: "false",
                returnDistinctValues: "true",
            };

            if (regionalPartnerCode != "" && regionalsGeo.length > 0) {
                let regioanlGeo = regionalsGeo.filter((item) => item.attributes.country_code.toUpperCase() == regionalPartnerCode.toUpperCase())
                if (regioanlGeo.length > 0) {
                    const regionalGeometry = regioanlGeo[0].geometry;
                    const pointCount = getGeometryPointCount(regionalGeometry);
                    const useEnvelope = pointCount > 500;
                    const envelopeGeometry = useEnvelope ? geometryToEnvelope(regionalGeometry) : null;

                    queryParams.geometry = JSON.stringify(envelopeGeometry || regionalGeometry);
                    queryParams.geometryType = envelopeGeometry ? "esriGeometryEnvelope" : "esriGeometryPolygon";
                    queryParams.spatialRel = "esriSpatialRelIntersects";
                    queryParams.inSR = String(regionalGeometry?.spatialReference?.wkid || 4326);
                }
            }

            const hasSpatialFilter = Boolean(queryParams.geometry);
            let results;
            let usedSpatialFallback = false;
            let usedDistinctFallback = false;

            try {
                results = await executeArcgisQuery(service, queryParams);
            } catch (error) {
                const failedExecuteQuery = /failed to execute query\.?/i.test(error?.message || "");

                if (!failedExecuteQuery) {
                    throw error;
                }

                let lastError = error;
                let baseFallbackParams = { ...queryParams };

                if (hasSpatialFilter) {
                    delete baseFallbackParams.geometry;
                    delete baseFallbackParams.geometryType;
                    delete baseFallbackParams.spatialRel;
                    delete baseFallbackParams.inSR;

                    try {
                        results = await executeArcgisQuery(service, baseFallbackParams);
                        usedSpatialFallback = true;
                    } catch (spatialError) {
                        lastError = spatialError;
                    }
                }

                if (!results) {
                    const distinctFallbackParams = {
                        ...baseFallbackParams,
                        returnDistinctValues: "false",
                    };

                    try {
                        results = await executeArcgisQuery(service, distinctFallbackParams);
                        usedDistinctFallback = true;
                    } catch (distinctError) {
                        throw distinctError || lastError;
                    }
                }
            }

            const uniqueValues = [...new Set((results.features || [])
                .map((item) => item.attributes?.[serviceName])
                .filter((value) => value !== null && value !== undefined && value !== ""))];

            const list = uniqueValues.map((value) => ({
                "idAuxtabledetail": value,
                "txtDescription": value,
            }));

            if (usedSpatialFallback || usedDistinctFallback) {
                console.log("[ROUTE_DEBUG] route query fallback applied", {
                    service,
                    serviceName,
                    usedSpatialFallback,
                    usedDistinctFallback,
                });
            }

            if (list.length > 0) {
                if (transportId == 87 || transportId == 88) {
                    setOcultar(false);
                    setRouters(list);
                }
                else if (transportId == 91) {
                    setOcultar(false);
                    setRouters(list);
                }
                else if (transportId == 89 || transportId == 90 || transportId == 144 || transportId == 143 || transportId == 146 || transportId == 153) {
                    setOcultar(true);
                    setRouters(list);
                    setInput('');
                }
                else {
                    setOcultarType(true);
                    setRouters(list);
                }
            }
            else {
                setRouters([]);
                setShowNoData(true)
                return;
            }
        } catch (error) {
            console.log("[ROUTE_DEBUG] query route list failed", {
                service,
                serviceName,
                regionalPartnerCode,
                message: error?.message || "unknown error",
                code: error?.arcgisCode,
                details: error?.arcgisDetails,
            });
            setRouters([]);
            setShowNoData(true);
        } finally {
            setIsLoadingRoutes(false);
        }
    }

    const getValueGDB = async (e, type) => {
        setShowNoData(false)
        var id = e.target.value;
        const parsedId = parseInt(id, 10);

        if (!id || Number.isNaN(parsedId)) {
            setidTransport(0);
            setRouters([]);
            setIsLoadingRoutes(false);
            return;
        }
        //Freight, Airports, Saeports, IWWW Ports, Railways Border Crossing, Roads Border Crossing, 
        let nodes = [90, 143, 144, 146, 153];
        //Roads, Railways, IWW, 
        let routes = [87, 88, 91];
        //Freight
        let freight = 89;
        setidTransport(parsedId);

        if (nodes.includes(parsedId)) {
            setIsHiddenTrasnport(true);
            setIsHiddenCore(true);

            // var service = UrlServicesTypeTrasnporte[parseInt(id)];
            // var serviceName = UrlServicesTypeTrasnporteName[parseInt(id)];
            // console.log("values of the service is ", service, serviceName);
        }
        if (routes.includes(parsedId)) {
            setIsHiddenTrasnport(false);
            setIsHiddenCore(false);
        }

        if(freight == id){
            setIsHiddenTrasnport(true);
            setIsHiddenCore(false);
        }

        if (id == 87 || id == 88) {
            setNameRouteID("ROUTE NAME");
        }
        if (id == 91) {
            setNameRouteID("RIVER NAME");
        }
        if (id == 89 || id == 90 || id == 144 || id == 143) {
            setNameRouteID("NAME");
        }
        if (id == 146 || id == 153) {
            setNameRouteID("COUNTRY NAME");
        }

        await loadRouteOptions(parsedId, rp);
    }

    const getRoute = async (e, routeId) => {

        var service = UrlServicesNode[idTransport];
        var serviceName = UrlServicesfilterNode[idTransport];
        var id = e.target.value;

        if (!service || !serviceName || !id) {
            setstartNode([]);
            setendNode([]);
            return;
        }

        try {
            const escapedId = String(id).replace(/'/g, "''");
            const results = await executeArcgisQuery(service, {
                where: serviceName + "='" + escapedId + "'",
                returnGeometry: "false",
                returnDistinctValues: "true",
                outFields: "node_name",
            });

            const uniqueNodes = [...new Set((results.features || [])
                .map((item) => item.attributes?.node_name)
                .filter((value) => value !== null && value !== undefined && value !== ""))];

            const list = uniqueNodes.map((value) => ({
                "idAuxtabledetail": value,
                "txtDescription": value,
            }));

            setstartNode(list);
            setendNode(list);
        } catch (error) {
            console.log("[ROUTE_DEBUG] query node list failed", {
                service,
                serviceName,
                routeId: id,
                message: error?.message || "unknown error"
            });
            setstartNode([]);
            setendNode([]);
        }
    }
    const [modalShow, setModalShow] = useState(false);

    const onSubmit = async (values, { resetForm }) => {
        const loadingSwal = Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            //showCancelButton: true,
            //cancelButtonText: 'Close',
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            //values.validFrom = dateFormat(values.validFrom, "yyyy-mm-dd");
            //values.validTo = dateFormat(values.validTo, "yyyy-mm-dd");
            let validFor = values.validFrom.year.toString();
            let startNode = values.startKm;
            let endNode = values.endKm;
            let regional =

                // let startNodeName = values.startKm.toString();
                // let endNodeName = values.endKm.toString();
                delete values.validFrom;
            delete values.startKm;
            delete values.endKm;
            //console.log("data Form", values);
            const res = await new RequestService("workflow/request").createRequest({ ...values, name: "Data Collection", validFor, startNode, endNode, tentCategory: values.tentCategory, regionalPartnar: parseInt(values.regionalPartnar) });
            // console.log("data Form", values);
            // const res = await new RequestService("workflow/request").createRequest({ ...values, name: "Data Collection" });
            if (res.status > 200 && res.status < 300) {
                Swal.close();
                resetForm();
                props.onHide()
                props.pushRequest()
                setModalShow(true);
            } else {
                Swal.close();
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'An unexpected error occurred while creating the update request.',
                    showConfirmButton: true
                });
                console.log("error in create Task", res);
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'An unexpected error occurred while creating the update request.',
                showConfirmButton: true
            });
            console.log("error in create Task", error);
        }
    }
    return (
        <Container fluid className="todis-form-wrapper p-3" style={{ height: "100%" }}>
            <Row>
                <Formik
                    initialValues={TASK}
                    validationSchema={TODIS_TASK}
                    onSubmit={onSubmit}>
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form className="todis-form-content p-0">
                            <Container>
                                <Row>


                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_GDB onchange={(e) => typeOnchage(e, 'projectType')} id="projectType" label="MODULE" name="projectType" type="select" options={tasks} disabled={OcultarType} />
                                        {errors.projectType && touched.projectType ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.projectType}</div>) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_GDB id="regionalPartnar" onchange={(e) => regionalOnChange(e)} label="REGIONAL PARTNER" name="regionalPartnar" type="select" options={regionals} />
                                        {errors.regionalPartnar && touched.regionalPartnar ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.regionalPartnar}</div>) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_GDB onchange={(e) => getValueGDB(e, 'transportType')} id="transportType" label="TRANSPORT MODE" name="transportType" type="select" options={transports} placeholder="Regional Partner" />
                                        {errors.transportType && touched.transportType ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.transportType}</div>) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_OPTIONS_DESC id="assignedTo" label="ASSIGNED TO" name="assignedTo" type="select" options={personals} />
                                        {errors.assignedTo && touched.assignedTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.assignedTo}</div>) : null}
                                    </Col>

                                    {/* <Col lg={6}>
                                                <TODIS_FORM_FIELD_OPTIONS_DESC id="assignedTo" label="ASSIGNED TO" name="assignedTo" type="select" options={personals} />
                                                {errors.assignedTo && touched.assignedTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.assignedTo}</div>) : null}
                                            </Col> */}
                                    <Col lg={6} style={{ position: "relative" }}>
                                        {isLoadingRoutes ? <div className="flex gap-3 w-100 justify-content-end" style={{ position: "absolute", right: "-80%", top: "0px" }}> <small>Loading Data</small> <FaSpinner className="loading-icon" /></div> : null}
                                        <TODIS_FORM_FIELD_OPTIONS_GDB id="routeId" onchange={(e) => getRoute(e, 'routeId', 'transportType',)} label={NameRouteID} name="routeId" type="select" options={routers} disabled={isLoadingRoutes} />
                                        {errors.routeId && touched.routeId ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.routeId}</div>) : null}
                                        {routers.length == 0 && showNoData ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>No Data Found</div>) : null}
                                    </Col>

                                    <Col lg={6}>
                                        {(!isHiddenTrasnport || !isHiddenCore) ? <><TODIS_FORM_FIELD_OPTIONS_DESC id="tentCategory" label="TENT CATEGORY" name="tentCategory" type="select" options={tentCategory} />
                                            {errors.tentCategory && touched.tentCategory ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.tentCategory}</div>) : null}
                                        </> : null}
                                    </Col>

                                    {(!isHiddenTrasnport && !isHiddenCore) ?
                                        <>
                                            <Col lg={3}>
                                                <TODIS_FORM_FIELD_OPTIONS_GDB id="startKm" label="START NODE" name="startKm" disabled={Ocultar} options={startNode} />
                                                {errors.startKm && touched.startKm ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.startKm}</div>) : null}
                                            </Col>

                                            <Col lg={3}>
                                                <TODIS_FORM_FIELD_OPTIONS_GDB id="endKm" label="END NODE" name="endKm" disabled={Ocultar} options={endNode} />
                                                {errors.endKm && touched.endKm ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.endKm}</div>) : null}
                                            </Col>
                                        </>
                                        :
                                        <></>
                                    }
                                    {/* <Col lg={6}>
                                                <TODIS_FORM_FIELD_DATE_YEAR id="validFrom" label="Year" name="validFrom" setFieldValue={setFieldValue} />
                                                {errors.validFrom && touched.validFrom ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.validFrom}</div>) : null}
                                            </Col> */}

                                    {/* <Col lg={3}>
                                        <TODIS_FORM_FIELD_DATE_RQ id="validTo" label="VALID TO" name="validTo" placeholder="Valid To" validateFrom={values.validFrom} />
                                        {errors.validTo && touched.validTo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.validTo}</div>) : null}
                                    </Col> */}

                                    <Col lg={6}>
                                        <TODIS_FORM_FIELD_DATE_YEAR id="validFrom" label="YEAR" name="validFrom" setFieldValue={setFieldValue} />
                                        {errors.validFrom && touched.validFrom ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.validFrom}</div>) : null}
                                    </Col>
                                    <Col lg={12}>
                                        <TODIS_FORM_DSC id="description" label="DESCRIPTION" name="description" text="" style={{ height: "auto" }}></TODIS_FORM_DSC>
                                        {errors.description && touched.description ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.description}</div>) : null}
                                    </Col>
                                    <div className="todis-action-form">
                                        <Button variant="outline-danger" onClick={() => props.onHide()} className={style.todisBtnOutline}>DISCARD </Button>
                                        <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{ margin: "0.5rem" }}><BsPlusLg className="me-3" />CREATE REQUEST </Button>
                                    </div>
                                </Row>
                            </Container>

                            <TODIS_MODAL show={modalShow} onHide={() => setModalShow(false)} title="Creating Task" bodyText="Task has been created" iconBody={RiCheckboxCircleFill} />
                        </Form>
                    )}
                </Formik>
            </Row>
        </Container>
    );
}

export default FormRequest;